import { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Api from "../../../../constants/Api";
import MenuConfig from "../../../../constants/MenuConfig";
import { getId } from "../../../../utils/ApiUtils";
import { convertBooleanToStatus } from "../../../../utils/ConverterUtils";
import { ApiError } from "../../../components/Common/ApiError";
import NewPage from "../../../layouts/page/NewPage";
import PerformancePlanEmployeeForm from "./PerformancePlanEmployeeForm";
import axiosInstance from "../../../../services/AxiosInstance";
import { successAlert } from "../../../components/alert/defaultAlert";

const PerformancePlanEmployeeNew = () => {

    const { t } = useTranslation();
    const navigate = useNavigate();
    const [status, setStatus] = useState(true);
    const [entityData, setEntityData] = useState(null);

    const formik = useFormik({
        initialValues: {
            employees: [],
            plan: null,
            startDate: "",
            endDate: ""
        },
        validationSchema: Yup.object().shape({
            employees: Yup.array().min(1, t('validation.required.employee')),
            plan: Yup.object().nullable().required(t('performance.validation.plan_required')),
            startDate: Yup.string().required(t('validation.required.start_date'))
        }),
        onSubmit: values => {
            const buildPayload = (employee) => ({
                id: entityData ? getId(entityData) : null,
                employee: { id: employee.value },
                plan: { id: values.plan.value },
                startDate: values.startDate,
                endDate: values.endDate || null,
                status: convertBooleanToStatus(status)
            });

            const employees = entityData ? values.employees.slice(0, 1) : values.employees;
            const requests = employees.map(employee => {
                const payload = buildPayload(employee);
                return payload.id
                    ? axiosInstance.patch(Api.performance.employee_plan + "/" + payload.id, payload)
                    : axiosInstance.post(Api.performance.employee_plan, payload);
            });

            Promise.all(requests)
                .then(() => {
                    successAlert(t('message.operation_successfully'), () => {
                        navigate(MenuConfig.performance.employee_plan.route);
                    });
                })
                .catch((error) => {
                    ApiError(error);
                    formik.setSubmitting(false);
                });
        }
    });

    const onSubmit = (e) => {
        e.preventDefault();
        formik.handleSubmit();
    };

    return (
        <NewPage
            motherMenu={t('performance.label')}
            childMenu={t('performance.employee_plans')}
            activeMenu={t('new')}
            child={<PerformancePlanEmployeeForm formik={formik} status={status} setStatus={setStatus} entityData={entityData} />}
            setEntityData={setEntityData}
            path={Api.performance.employee_plan}
            isSubmitting={formik.isSubmitting}
            handleSubmit={onSubmit}
            cancelRoute={MenuConfig.performance.employee_plan.route}
        />
    );
}

export default PerformancePlanEmployeeNew;
